import logo from './logo.svg';
import './App.css';
import MainRoutes from './routes/MainRoutes';
import Navbar from './components/Navbar';
import HeroImg from './components/HeroImg'
import Footer from './components/Footer'
import WorkCard from './components/WorkCard'
import AboutContent from './components/AboutContent';
import SkillCard from './components/SkillCard';
import Form from './components/Form';
import Git from './components/Git';

function App() {
  return (
    <div className="App">
      {/* <MainRoutes /> */}
        <Navbar />
        <HeroImg />
        <AboutContent />
        <WorkCard />
        <SkillCard />
        <Git />
        <Form />
        <Footer />
    </div>
  );
}

export default App;
